import AxiosInstance from "./axiosInstance";

export const listAllQuotation = () => {
  return AxiosInstance.get("/quotation")
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};

export const getQuotation = (id) => {
  return AxiosInstance.get(`/quotation/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const updateQuotation = (id, data) => {
  return AxiosInstance.patch(`/quotation/${id}`, data)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
export const deleteQuotation = (id) => {
  return AxiosInstance.delete(`/quotation/${id}`)
    .then((res) => {
      if (res.status === 200) return res.data;
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
};
